<template>
  <div class="booking-tabs">
    <div class="booking-tabs__wrapper booking-tabs__wrapper--desktop">
      <router-link v-for="tab in tabs"
                   :key="tab.id"
                   :to="tab.link"
                   :class="[`booking-tabs__tile--${tab.id}`]"
                   class="booking-tabs__tile">
        <div class="booking-tabs__tile-icon"></div>
        <h2 class="booking-tabs__tile-title">{{ tab.title }}</h2>
      </router-link>
    </div>
    <div class="booking-tabs__wrapper booking-tabs__wrapper--mobile">
      <sk-select :description="assignmentTypeText"
                 :default-value="assignmentTypeText"
                 :items-list="tabs"
                 :preselected-value="assignmentType"
                 class="booking-tabs__select"
                 @csvaluechanged="setAssignmentType" />
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    props: {
      isTranslation: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        assignmentType: this.$route.meta.assignmentType || ''
      };
    },
    computed: {
      ...mapGetters('UserInfoStore', [
        'allowNewTranslationServices',
        'allowInterpretationServices',
        'userIsBusiness',
        'userCanSeeTranslations',
        'isTranslationOnly'
      ]),
      assignmentTypeText() {
        return this.$gettext('Select assignment type');
      },
      showTranslationTab() {
        return this.allowNewTranslationServices || this.userCanSeeTranslations;
      },
      interpretationTabsList() {
        return [{
          id: 'interpretation',
          link: this.$makeRoute({name: 'BuyerPostInterpretation'}),
          title: this.$gettext('Interpreter'),
          condition: (this.allowInterpretationServices || this.userIsBusiness) && !this.isTranslationOnly
        }, {
          id: 'fast_interpretation',
          link: this.$makeRoute({name: 'BuyerPostFastInterpretation'}),
          title: this.$gettext('Hast'),
          condition: this.$store.getters['PostingNotifierStore/showFastInterpretationForm'] && this.allowInterpretationServices
        }, {
          id: 'series_interpretation',
          link: this.$makeRoute({name: 'BuyerPostSeriesInterpretation'}),
          title: this.$gettext('Series'),
          condition: this.$store.getters['UserInfoStore/userCanShowSeriesOrderFeature']
        }, {
          id: 'secretary',
          link: this.$makeRoute({name: 'BuyerPostSecretaryInterpretation'}),
          title: this.$gettext('Secretary'),
          condition: this.$store.getters['UserInfoStore/userCanShowSecretaryAssignmentFeature']
        }, {
          id: 'translation',
          link: this.$makeRoute({name: 'BuyerPostTranslationProject'}),
          title: this.$pgettext('translation', 'Translation'),
          condition: this.allowNewTranslationServices || this.userCanSeeTranslations
        }];
      },
      translationTabsList() {
        return [{
          id: 'translation',
          link: this.$makeRoute({name: 'BuyerPostTranslationProject'}),
          title: this.$pgettext('translation', 'Translation'),
          condition: this.showTranslationTab
        }, {
          id: 'correction',
          link: this.$makeRoute({name: 'BuyerPostCorrectionProject'}),
          title: this.$pgettext('translation', 'Correction'),
          condition: this.showTranslationTab
        }, {
          id: 'in_person',
          link: this.$makeRoute({name: 'BuyerPostInPersonProject'}),
          title: this.$pgettext('translation', 'In person'),
          condition: this.showTranslationTab
        }, {
          id: 'interpretation',
          link: this.$makeRoute({name: 'BuyerPostInterpretation'}),
          title: this.$gettext('Interpretation'),
          condition: (this.allowInterpretationServices || this.userIsBusiness) && !this.isTranslationOnly
        }];
      },
      tabs() {
        const tabList = this.isTranslation ? this.translationTabsList : this.interpretationTabsList;
        return tabList.filter((tab) => tab.condition);
      }
    },
    methods: {
      setAssignmentType(assignmentType) {
        const tab = this.tabs.find((tab) => tab.id === assignmentType) || {};

        this.assignmentType = assignmentType;
        this.$router.push(tab.link);
      }
    }
  };
</script>

<style scoped>
  .booking-tabs {
    border-bottom: 1px solid #d3d5de;
  }

  .booking-tabs__wrapper {
    display: flex;
    width: calc(100% + 30px);
    margin-right: -15px;
    margin-left: -15px;
  }

  .booking-tabs__tile {
    display: flex;
    align-items: center;
    margin: 0 15px;
    padding: 0 2px 10px;
    border-bottom: 2px solid transparent;
    border-radius: 1px;
    color: var(--black-500);
  }

  .booking-tabs__tile-title {
    margin-left: 10px;
    font-weight: 400;
    font-size: 14px;
    line-height: 1;
  }

  .booking-tabs__tile.router-link-active {
    border-bottom: 2px solid var(--color-black);
    color: var(--color-black);
  }

  .booking-tabs__tile:hover {
    color: var(--color-black);
  }

  .booking-tabs__tile:focus {
    outline: var(--default-button-focus-outline);
  }

  .booking-tabs__tile-icon {
    width: 20px;
    height: 25px;
    background-position: center left;
    background-size: contain;
    background-repeat: no-repeat;
  }

  .booking-tabs__tile--interpretation .booking-tabs__tile-icon {
    background-image: var(--booking-tab-interpretation);
  }

  .booking-tabs__tile--interpretation:hover .booking-tabs__tile-icon,
  .booking-tabs__tile--interpretation.router-link-active .booking-tabs__tile-icon {
    background-image: var(--booking-tab-interpretation-active);
  }

  .booking-tabs__tile--fast_interpretation .booking-tabs__tile-icon {
    background-image: var(--booking-tab-fast-interpretation);
  }

  .booking-tabs__tile--fast_interpretation:hover .booking-tabs__tile-icon,
  .booking-tabs__tile--fast_interpretation.router-link-active .booking-tabs__tile-icon {
    background-image: var(--booking-tab-fast-interpretation-active);
  }

  .booking-tabs__tile--series_interpretation .booking-tabs__tile-icon {
    background-image: var(--booking-tab-series-interpretation);
  }

  .booking-tabs__tile--series_interpretation:hover .booking-tabs__tile-icon,
  .booking-tabs__tile--series_interpretation.router-link-active .booking-tabs__tile-icon {
    background-image: var(--booking-tab-series-interpretation-active);
  }

  .booking-tabs__tile--secretary .booking-tabs__tile-icon {
    background-image: var(--booking-tab-secretary);
  }

  .booking-tabs__tile--secretary:hover .booking-tabs__tile-icon,
  .booking-tabs__tile--secretary.router-link-active .booking-tabs__tile-icon {
    background-image: var(--booking-tab-secretary-active);
  }

  .booking-tabs__tile--translation .booking-tabs__tile-icon {
    background-image: var(--booking-tab-translation);
  }

  .booking-tabs__tile--translation:hover .booking-tabs__tile-icon,
  .booking-tabs__tile--translation.router-link-active .booking-tabs__tile-icon {
    background-image: var(--booking-tab-translation-active);
  }

  /* booking tabs translation */
  .booking-tabs__tile--in_person .booking-tabs__tile-icon {
    background-image: var(--image-assignment-in-person-translation-icon);
  }

  .booking-tabs__tile--in_person:hover .booking-tabs__tile-icon,
  .booking-tabs__tile--in_person.router-link-active .booking-tabs__tile-icon {
    background-image: var(--image-assignment-in-person-translation-active-icon);
  }

  .booking-tabs__tile--correction .booking-tabs__tile-icon {
    background-image: var(--image-assignment-correction-translation-icon);
  }

  .booking-tabs__tile--correction:hover .booking-tabs__tile-icon,
  .booking-tabs__tile--correction.router-link-active .booking-tabs__tile-icon {
    background-image: var(--image-assignment-correction-translation-active-icon);
  }

  .booking-tabs__wrapper--mobile {
    display: none;
  }

  .booking-tabs__select {
    padding: 0 15px;
  }

  @media (max-width: 767px) {
    .booking-tabs {
      border-bottom: none;
    }

    .booking-tabs__wrapper--desktop {
      display: none;
    }

    .booking-tabs__wrapper--mobile {
      display: block;
    }
  }
</style>
